import { render, staticRenderFns } from "./Zcfg.vue?vue&type=template&id=56963482&scoped=true&"
import script from "./Zcfg.vue?vue&type=script&lang=js&"
export * from "./Zcfg.vue?vue&type=script&lang=js&"
import style0 from "./Zcfg.vue?vue&type=style&index=0&id=56963482&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56963482",
  null
  
)

export default component.exports